import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errText } from "@/lib/api";
import { Panel, Btn, fmt, useOps } from "./ui";
import { Mark } from "./HealthChecks";

function Item({ i, onToggle }) {
  return (
    <div data-testid={`golive-item-${i.id}`} className="flex items-start gap-2 border-b border-[#243144] py-1.5 text-xs last:border-0">
      {i.kind === "manual" ? (
        <input type="checkbox" className="mt-0.5" checked={i.ok} onChange={(e) => onToggle(i.id, e.target.checked)} data-testid={`golive-manual-${i.id}`} />
      ) : i.kind === "info" ? <span className="mono w-10 shrink-0 text-[10px] text-sky-300">INFO</span> : <Mark ok={i.ok} />}
      <div className="min-w-0">
        <div className={i.ok || i.kind === "info" ? "text-slate-200" : "text-slate-100"}>{i.label}</div>
        {i.detail && <div className={`break-all text-[11px] ${i.kind === "manual" && !i.ok ? "text-amber-300" : "text-slate-500"}`}>{i.detail}</div>}
        {i.kind === "manual" && i.ok && i.at && <div className="text-[10px] text-slate-600">ticked {fmt(i.at)}</div>}
      </div>
    </div>
  );
}

export default function GoLive() {
  const { api } = useOps();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/golive").then((r) => setD(r.data)), [api]);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  const toggle = async (key, done) => {
    try { const r = await api.put(`/golive/manual/${key}`, { done }); setD(r.data); } catch (e) { toast.error(errText(e)); }
  };
  const rerun = async () => {
    setBusy(true);
    try { await api.post("/healthchecks/run"); await load(); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  const health = d.auto.filter((i) => i.kind === "health");
  const system = d.auto.filter((i) => i.kind !== "health");
  return (
    <div className="space-y-3" data-testid="admin-golive">
      <div data-testid="golive-status" className={`rounded border px-3 py-2 text-sm ${d.ready ? "border-green-700 bg-green-950/40 text-green-300" : "border-amber-700 bg-amber-950/30 text-amber-200"}`}>
        {d.ready ? "Ready to open to players." : `${d.blocking} item${d.blocking === 1 ? "" : "s"} still open before go-live.`}
      </div>
      <div className="grid gap-3 lg:grid-cols-3">
        <Panel title="Health checks" actions={<Btn onClick={rerun} disabled={busy} data-testid="golive-run-checks">{busy ? "Checking…" : "Run checks now"}</Btn>}>
          {health.map((i) => <Item key={i.id} i={i} />)}
        </Panel>
        <Panel title="System & content">{system.map((i) => <Item key={i.id} i={i} />)}</Panel>
        <Panel title="Your sign-off">{d.manual.map((i) => <Item key={i.id} i={i} onToggle={toggle} />)}</Panel>
      </div>
    </div>
  );
}
